<template>
  <yi-brand-list></yi-brand-list>
</template>

<script>
export default {
  name: 'brandList',
};
</script>

<style scoped></style>
